<div *ngIf="roomRulesVisible"
	[class]="options?.cssClass || ''">
	<div class="rules-container"
		[@slideInOut]="{ value: animationState }"
		[ngClass]="{
			'closed-panel': ruleWorkFlow.section === ruleWorkflowSection.CLOSED,
			'inline': options.layout === roomRulesDesign.INLINE,
			'full-width': options.layout !== roomRulesDesign.INLINE,
			'with-subheader': ruleWorkFlow.section === ruleWorkflowSection.COMMENT ||
							ruleWorkFlow.section === ruleWorkflowSection.COMMENT_LIST ||
							ruleWorkFlow.section === ruleWorkflowSection.STIPS ||
							ruleWorkFlow.section === ruleWorkflowSection.STIPS_LIST ||
							(options.layout === roomRulesDesign.FULL_WIDTH && ruleWorkFlow.section === ruleWorkflowSection.NEW)
		}">
		
		<div class="flex-container inline-header-container" 
			*ngIf="(options.layout === roomRulesDesign.INLINE && 
					(ruleWorkFlow.section === ruleWorkflowSection.LIST
					|| ruleWorkFlow.section === ruleWorkflowSection.CLOSED)) 
					|| options.layout === roomRulesDesign.FULL_WIDTH">

			<div class="inline-header-item inline-title">
				<label>
					Rules
					<span *ngIf="options.layout === roomRulesDesign.FULL_WIDTH">
						({{
						(ruleWorkFlow.availableRulesOf.Info
						+ ruleWorkFlow.availableRulesOf.Warning
						+ ruleWorkFlow.availableRulesOf.Error)
						}})
					</span>
				</label>
			</div>

			<div class="inline-header-item rules-indicator">
				<div class="rules-filters">
					<div class="actions d-inline-block float-right">
						<span *ngIf="options.layout === roomRulesDesign.FULL_WIDTH">Filter: </span>
						<span (click)="onTypeFiltersChange(ruleMessageType.Info)"
							[ngClass]="{ active: containsFilter(ruleMessageType.Info) }"
							title="Info Rules"
							class="badge badge-primary active">
							{{ ruleWorkFlow.availableRulesOf.Info }}
						</span>
						<span (click)="onTypeFiltersChange(ruleMessageType.Warning)"
							[ngClass]="{ active: containsFilter(ruleMessageType.Warning) }"
							title="Warning Rules"
							class="badge badge-warning active">
							{{ ruleWorkFlow.availableRulesOf.Warning }}
						</span>
						<span (click)="onTypeFiltersChange(ruleMessageType.Error)"
							[ngClass]="{ active: containsFilter(ruleMessageType.Error) }"
							title="Error Rules"
							class="badge badge-danger active">
							{{ ruleWorkFlow.availableRulesOf.Error }}
						</span>
						<span class="divider"></span>
						<button *ngIf="activeActions" (click)="changeRuleFlow(ruleWorkflowSection.NEW)"
							class="btn btn-sm btn-light btn-create-rule"
							title="Create New Rule">
							<small *ngIf="options.layout === roomRulesDesign.FULL_WIDTH">ADD&nbsp;</small>
							<i class="fas fa-plus"></i>
						</button>
					</div>
				</div>
			</div>

			<div class="inline-header-item inline-action"
				*ngIf="options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.CLOSED"
				(click)="changeRuleFlow(ruleWorkflowSection.LIST)">
				<i class="fas fa-chevron-right"></i>
			</div>

			<div class="inline-header-item inline-action"
				*ngIf="options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section !== ruleWorkflowSection.CLOSED"
				(click)="changeRuleFlow(ruleWorkflowSection.CLOSED)">
				<i class="fas fa-chevron-down"></i>
			</div>

		</div>

		<div class="flex-container inline-header-container"
			*ngIf="options.layout === roomRulesDesign.FULL_WIDTH && ruleWorkFlow.section === ruleWorkflowSection.NEW">
			<div class="inline-header-item inline-action" (click)="changeRuleFlow(ruleWorkflowSection.LIST)">
				<i class="fas fa-arrow-left"></i>
			</div>
			<div class="inline-header-item inline-title"><label>Back to list</label></div>
		</div>

		<div class="flex-container inline-header-container"
			*ngIf="options.layout === roomRulesDesign.INLINE && 
				(ruleWorkFlow.section === ruleWorkflowSection.DETAIL || ruleWorkFlow.section === ruleWorkflowSection.NEW)">
			<div class="inline-header-item inline-action" (click)="changeRuleFlow(ruleWorkflowSection.LIST)">
				<i class="fas fa-arrow-left"></i>
			</div>
			<div class="inline-header-item inline-title"><label>Back to list</label></div>
			<div class="inline-header-item inline-title inline-pre-next"
				*ngIf="options.layout === roomRulesDesign.INLINE && 
					(ruleWorkFlow.section === ruleWorkflowSection.DETAIL && ruleWorkFlow.filteredRuleViolations.length > 1)">
				<label (click)="previousRule()" title="Previous Rule"><i class="fas fa-chevron-left"></i></label>
				<label title="Total">
					{{this.ruleWorkFlow.selectedRule.index + 1}} of {{this.ruleWorkFlow.filteredRuleViolations.length }}
				</label>
				<label (click)="nextRule()" title="Next Rule"><i class="fas fa-chevron-right"></i></label>
			</div>
		</div>

		<div class="flex-container inline-header-container"
			*ngIf="ruleWorkFlow.section === ruleWorkflowSection.COMMENT ||
					ruleWorkFlow.section === ruleWorkflowSection.COMMENT_LIST ||
					ruleWorkFlow.section === ruleWorkflowSection.STIPS ||
					ruleWorkFlow.section === ruleWorkflowSection.STIPS_LIST">

			<div class="inline-header-item inline-action"
				(click)="changeRuleFlow(ruleWorkflowSection.DETAIL, ruleWorkFlow.selectedRule)">
				<i class="fas fa-arrow-left"></i>
			</div>
			<div class="inline-header-item inline-title"><label>Back to Detail</label></div>
		</div>

		<div class="inline-body flex-container">
			<div class="inline-body-wrapper"
				*ngIf="options.layout === roomRulesDesign.FULL_WIDTH && 
					(ruleWorkFlow.section === ruleWorkflowSection.LIST || ruleWorkFlow.section === ruleWorkflowSection.DETAIL)">

				<div *ngFor="let ruleViolation of ruleWorkFlow.filteredRuleViolations; let i = index;"
					class="rule-header"
					[ngClass]="{
						'empty-rules': ruleWorkFlow.rulesShown === 0
					}">
					<cv-schema-render-rule-item
						[version]="options.layout"
						[path]="path"
						[ruleViolation]="ruleViolation"
						[collapsibleName]="'item_' + ruleViolation.ruleName"
						[activeActions]="activeActions"
						[ruleWorkFlow]="ruleWorkFlow"
						[selectedItem]="'item_' + selectedItem">
					</cv-schema-render-rule-item>
				</div>

				<div class="empty-rules-message"
					*ngIf="currentFilters.length === 0 ||
						ruleSetViolations.length === 0 ||
						ruleWorkFlow.rulesShown === 0">
					<div>
						<label class="no-results">No rules available</label>
					</div>
				</div>
			</div>

			<div class="inline-body-wrapper"
				*ngIf="options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.LIST">

				<div *ngFor="let ruleViolation of ruleWorkFlow.filteredRuleViolations; let i = index;" 
					class="rule-header"
					[ngClass]="{
						'empty-rules': ruleWorkFlow.rulesShown === 0
					}">
					<cv-schema-render-rule-item
						[version]="options.layout"
						[path]="path"
						[ruleViolation]="ruleViolation"
						[collapsibleName]="'item_' + ruleViolation.ruleName"
						[activeActions]="activeActions"
						[ruleWorkFlow]="ruleWorkFlow"
						[selectedItem]="'item_' + selectedItem">
					</cv-schema-render-rule-item>
				</div>
				<div *ngIf="currentFilters.length === 0 ||
                        	ruleSetViolations.length === 0 ||
                        	ruleWorkFlow.rulesShown === 0" class="empty-rules-message">
					<div>
						<label class="no-results">No rules available</label>
					</div>
				</div>
			</div>

			<div class="inline-body-wrapper"
				*ngIf="ruleWorkFlow.section === ruleWorkflowSection.COMMENT ||
					ruleWorkFlow.section === ruleWorkflowSection.COMMENT_LIST ||
					ruleWorkFlow.section === ruleWorkflowSection.STIPS ||
					ruleWorkFlow.section === ruleWorkflowSection.STIPS_LIST ||
					(options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.DETAIL)">

				<div class="rule-header"
					*ngIf="options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.DETAIL">
					<div class="flex-container">
						<div class="rule-title">
							<div class="rule-title-wrapper">
								<i class="fas" 
									[ngClass]="{
										'fa-exclamation-triangle': ruleWorkFlow.selectedRule.messageType === ruleMessageType.Warning,
										'fa-ban': ruleWorkFlow.selectedRule.messageType === ruleMessageType.Error,
										'fa-check': ruleWorkFlow.selectedRule.messageType === ruleMessageType.Info
									}"></i>

								<h6>{{ruleWorkFlow.selectedRule.messageType}}</h6>
							</div>
						</div>

						<div class="rule-action">
							<div class="rule-actions">
								<cv-schema-render-rule-actions
									[ruleViolation]="ruleWorkFlow.selectedRule"
									[activeActions]="activeActions"
									[ruleWorkFlow]="ruleWorkFlow"
									[path]="path">
								</cv-schema-render-rule-actions>
							</div>
						</div>
					</div>
				</div>

				<div class="rule-body selectable-element"
					*ngIf="options.layout === roomRulesDesign.INLINE && 
						(ruleWorkFlow.section === ruleWorkflowSection.COMMENT ||
						ruleWorkFlow.section === ruleWorkflowSection.COMMENT_LIST ||
						ruleWorkFlow.section === ruleWorkflowSection.STIPS ||
						ruleWorkFlow.section === ruleWorkflowSection.STIPS_LIST)">
					<div class="rule-title selectable-element">
						<h5>{{ruleWorkFlow.selectedRule.displayText}}</h5>
					</div>
				</div>

				<cv-schema-render-display-rule-information
					*ngIf="options.layout === roomRulesDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.DETAIL"
					[path]="path"
					[options]="{displayTitle: true}"
					[activeActions]="activeActions"
					[ruleViolation]="ruleWorkFlow.selectedRule">
				</cv-schema-render-display-rule-information>

				<div>

					<div class="add-comment-wrapper" *ngIf="ruleWorkFlow.section === ruleWorkflowSection.COMMENT">
						<cv-schema-render-add-comment [path]="path"></cv-schema-render-add-comment>
					</div>
					<div class="add-comment-stips-list-wrapper"
						*ngIf="ruleWorkFlow.section === ruleWorkflowSection.COMMENT_LIST">
						<div *ngFor="let comment of ruleWorkFlow.selectedRule.notes">
							<cv-view-invision-rule-comments-component 
								[activeActions]="activeActions"
								[path]="path"
								[item]="comment"
								[type]="'comment'">
							</cv-view-invision-rule-comments-component>
						</div>
						<div class="empty-rules-message"
							*ngIf="!ruleWorkFlow.selectedRule.notes ||
                                	ruleWorkFlow.selectedRule.notes === null ||
                                	ruleWorkFlow.selectedRule.notes.length === 0">
							<div>
								<label class="no-results">No comments available</label>
								<button *ngIf="activeActions"
									(click)="changeRuleFlow(ruleWorkflowSection.COMMENT)"
									class="btn btn-link"
									type="button">
									<i class="fas fa-plus-circle"></i> Add Comment
								</button>
							</div>
						</div>
					</div>
					<cv-schema-render-add-stip
						*ngIf="ruleWorkFlow.section === ruleWorkflowSection.STIPS"
						[availableStips]="ruleWorkFlow.selectedRule.availableStips"
						[path]="path">
					</cv-schema-render-add-stip>
					<div class="add-comment-stips-list-wrapper"
						*ngIf="ruleWorkFlow.section === ruleWorkflowSection.STIPS_LIST">
						
						<div *ngFor="let stip of ruleWorkFlow.selectedRule.stips">
							<cv-view-invision-rule-comments-component 
								[activeActions]="activeActions"
								[path]="path"
								[item]="stip"
								[type]="'stip'">
							</cv-view-invision-rule-comments-component>
						</div>

						<div class="empty-rules-message"
							*ngIf="!ruleWorkFlow.selectedRule.stips ||
                            	ruleWorkFlow.selectedRule.stips === null ||
                            	ruleWorkFlow.selectedRule.stips.length === 0">
							<div>
								<label class="no-results">No Stips available</label>
								<button class="btn btn-link"
									*ngIf="activeActions !== false &&
										(ruleWorkFlow.selectedRule.availableStips &&
                                		ruleWorkFlow.selectedRule.availableStips !== null &&
                                		ruleWorkFlow.selectedRule.availableStips.length > 0)"
										(click)="changeRuleFlow(ruleWorkflowSection.STIPS)"
									type="button">
									<i class="fas fa-plus-circle"></i> Add a Stip
								</button>
							</div>
						</div>
						
					</div>
				</div>
			</div>

			<div class="inline-body-wrapper for-input-form" *ngIf="ruleWorkFlow.section === ruleWorkflowSection.NEW">
				<cv-schema-render-add-rule [path]="path"></cv-schema-render-add-rule>
			</div>
			<div *ngIf="displayNotification" class="notification text-center">
				{{notificationMessage}}
			</div>
		</div>
	</div>
</div>
